/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Eu_Hosted_LabelInputs */



/**
* | output |
* | --- |
* | "Hosted in Europe" |
*
* @param {Model_Eu_Hosted_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_eu_hosted_label = /** @type {((inputs?: Model_Eu_Hosted_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Eu_Hosted_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In Europa gehostet")
	return /** @type {LocalizedString} */ ("Hosted in Europe")
});